<template>
<div class="modal-content">
    <div class="modal-header">
        <h3 class="modal-title" id="itemDetailTitle">ตรวจสอบรายละเอียดบิล</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <span>เลขที่ใบเสร็จ: {{item.doc_no}}</span><br>
                <span>วันที่/เวลา: {{ dateTimeFormatDMY(item.create_time) }}</span><br>
                <span>ชื่อลูกค้า: {{ item.ar_code }}/{{ item.ar_name }}</span>
            </div>
            <div class="col-6">
                <span>รายการ: 1</span><br>
                <span>จำนวนรายการ: {{ numberFormatDecimal((item.length > 0) ? item.sub.length : 0) }}</span>
            </div>
        </div>
    </div>
    <div id="Tdtail" class="modal-body row pt-0 pb-0">
        <div class="col-6 p-2" style="overflow: auto;">
            <table style="width:100%">
                <thead>
                    <th>@</th>
                    <th>รายละเอียดสินค้า</th>
                    <th>จำนวน</th>
                    <th>ราคา</th>
                    <th>รวม</th>
                </thead>
                <tbody>
                    <tr v-for="(d, i) in item.sub" :key="'item'+i">
                        <td class="text-center">{{ i+1 }}</td>
                        <td class="text-left">{{ d.item_name }}</td>
                        <td class="text-left">{{ numberFormatDecimal(d.qty) }}</td>
                        <td class="text-right">{{ numberFormatDecimal(d.price) }}</td>
                        <td class="text-right">{{ numberFormatDecimal(d.amount) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-6 p-2" style="overflow: auto;">
            <table style="width:100%">
                <thead>
                    <th>รายละเอียด</th>
                    <th>มูลค่า</th>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-left">ราคารวม</td>
                        <td class="text-right">{{ numberFormatDecimal(item.total_amount) }}</td>
                    </tr>
                    <tr>
                        <td class="text-left">ส่วนลดรวม</td>
                        <td class="text-right">{{ numberFormatDecimal(item.discount_amount) }}</td>
                    </tr>
                    <tr>
                        <td class="text-left">ราคาสุทธิ</td>
                        <td class="text-right">{{ numberFormatDecimal(item.after_discount_amount) }}</td>
                    </tr>
                    <tr>
                        <td class="text-left">เงินสด</td>
                        <td class="text-right">{{ numberFormatDecimal(item.cash_amount) }}</td>
                    </tr>
                    <tr>
                        <td class="text-left">เงินโอน</td>
                        <td class="text-right">{{ numberFormatDecimal(item.bank_amount) }}</td>
                    </tr>
                    <tr>
                        <td class="text-left">เงินทอน</td>
                        <td class="text-right">{{ numberFormatDecimal(item.change_amount) }}</td>
                    </tr>
                    <tr>
                        <td class="text-left">ชื่อพนักงาน</td>
                        <td class="text-right">{{ item.create_by }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <button
        type="button"
        class="btn btn-secondary"
        data-dismiss="modal"
      >
        พิมพ์
      </button>
      <button
        type="button"
        class="btn btn-primary"
        data-dismiss="modal"
        aria-label="Close"
      >ปิดหน้าต่าง</button>
    </div>
</div>
</template>

<script>
export default {
  name: 'checkBillDetail',
  props: ['item'],
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style scoped>
.form-control:-moz-read-only {
  /* For Firefox */
  background-color: #fff;
}

.form-control:read-only {
  background-color: #fff;
}

#Tdtail {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#Tdtail td, #Tdtail th {
  border: 1px solid #ddd;
  padding: 5px;
}

#Tdtail tr:nth-child(even){background-color: #f2f2f2;}

#Tdtail tr:hover {background-color: #ddd;}

#Tdtail th {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
  background-color: #007bff;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/check_detail_bill.vue